import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Screenshots from Aimee and other team members show a high resolution,
 * But the layout from our app appears as if it has a height of ~560px and a width of ~1200px.
 * This hook is used to determine if the screen is tall enough to display the app in a more visually appealing way.
 * It may not be enough to check the resolution, there may be OS zoom going on.
 * @returns {boolean} - True if the screen is tall enough to display the app in a more visually appealing way.
 * */
const useIsTallScreen = () => useMediaQuery('(min-height:721px)');

export default useIsTallScreen;
